module.exports = "/static/assets/a69226a716d526754403451bee941325.png";